import React, { useState, useEffect } from 'react';
import { 
  FaTractor, FaWhatsapp, FaBars, FaTimes, 
  FaArrowRight, FaCalendarAlt, FaUser 
} from 'react-icons/fa';
import '../styles/landingPage.scss'; // Reutilizando seus estilos

import ksat from '../assets/ksatwebgis.png';
import dynaop from '../assets/portfolio_bg.png';
import diesel from '../assets/hero_bg.png';

const BLOG_POSTS = [
    {
    id: 1,
    title: "Diesel, soberania e a conta que o produtor paga sem perceber",
    excerpt: "Grandes usinas chegam a gastar R$ 50 milhões por ano só em diesel. Com a pressão geopolítica no Oriente Médio, esse custo não vai cair sozinho — mas parte dele está sob controle do produtor.",
    date: "08 Abr, 2026",
    author: "André Bandeli",
    image: diesel,
    link: "/blog/eficiencia-energetica",
    tag: "Gestão"
  },
    {
    id: 2,
    title: "A importância do mapeamento da Condutividade Hidráulica para a Saúde da Lavoura",
    excerpt: "Confira os dados coletados durante os testes de eficiência energética e tração realizados em parceria com o IPT.",
    date: "10 jan, 2026",
    author: "Equipe DynaAgTech",
    image: ksat,
    link: "/blog/dynamap",
    tag: "Pesquisa"
  },
];

const BlogPage = () => {
  const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsHeaderScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const openWhatsApp = (msg) =>
    window.open(`https://wa.me/5519995910565?text=${encodeURIComponent(msg)}`, '_blank');

  return (
    <div className="lp">
      {/* ── HEADER (Reutilizado da LP) ─────────────────────── */}
      <header className={`lp__header ${isHeaderScrolled ? 'lp__header--scrolled' : ''}`}>
        <div className="lp__header-inner">
          <a className="lp__logo" href="/">
            <FaTractor /><span>DYNA<em>TECH</em></span>
          </a>

          <nav className={`lp__nav ${isMenuOpen ? 'lp__nav--open' : ''}`}>
            <a href="/" className="lp__nav-link">Início</a>
            <a href="/blog" className="lp__nav-link lp__nav-link--active">Blog</a>
            
            <button className="lp__nav-cta" onClick={() => openWhatsApp('Gostaria de falar com a DynaAgTech.')}>
              <FaWhatsapp /> Contato
            </button>
          </nav>

          <button className="lp__menu-btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>

      {/* ── HERO BLOG ─────────────────────────────────────── */}
      <section className="lp__hero" style={{ minHeight: '40vh', height: 'auto', paddingTop: '160px', paddingBottom: '80px' }}>
        <div className="lp__hero-overlay" style={{ background: 'linear-gradient(180deg, #0A1A0B 0%, #122614 100%)' }} />
        <div className="lp__container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="lp__eyebrow" style={{ color: '#A8FF3E' }}>Conteúdo Técnico</div>
          <h1 className="lp__section-title lp__section-title--light">
            Blog <span>DynaAgTech</span>
          </h1>
          <p className="lp__section-sub lp__section-sub--light">
            Insights sobre engenharia agrícola, eficiência de frotas e inovação no campo.
          </p>
        </div>
      </section>

      {/* ── FEED DE POSTS ─────────────────────────────────── */}
      <section className="lp__problem" style={{ background: '#f9f9f9' }}>
        <div className="lp__container">
          <div className="lp__problem-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))' }}>
            {BLOG_POSTS.map((post) => (
              <article key={post.id} className="lp__problem-card" style={{ padding: 0, overflow: 'hidden', textAlign: 'left', '--card-accent-color': '#4A8A28' }}>
                <div style={{ width: '100%', height: '220px', overflow: 'hidden' }}>
                   <img src={post.image} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                
                <div style={{ padding: '2rem' }}>
                  <div style={{ display: 'flex', gap: '15px', fontSize: '0.85rem', color: '#666', marginBottom: '1rem' }}>
                    <span><FaCalendarAlt /> {post.date}</span>
                    <span><FaUser /> {post.author}</span>
                  </div>
                  
                  <h3 style={{ fontSize: '1.4rem', marginBottom: '1rem', color: '#111' }}>{post.title}</h3>
                  <p style={{ color: '#555', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
                    {post.excerpt}
                  </p>
                  
                  <a href={post.link} className="lp__btn lp__btn--outline-dark" style={{ border: 'none', padding: '0', color: '#4A8A28', fontWeight: 'bold' }}>
                    Ler artigo completo <FaArrowRight style={{ marginLeft: '8px' }} />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ── FOOTER (Simplificado) ─────────────────────────── */}
      <footer className="lp__footer">
        <div className="lp__container">
          <div className="lp__footer-bottom">
            <p>© 2025 DynaAgTech · AgTech de Otimização Agrícola.</p>
            <a href="/" style={{ color: '#A8FF3E', textDecoration: 'none', marginTop: '10px', display: 'block' }}>Voltar para a Home</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BlogPage;